const article = {
  slug: 'exports',
  title: 'Exports and your data',
  section: 'Data',
  body: `
# Exports

## List exports

Every core list (Customers, Rentals, Payments, Invoices, report tables)
has **Export CSV** - it exports the filtered view you're looking at.

## Full data export

**Settings -> Data export** produces a complete export of your
facility's data - customers, units, rentals, payments, invoices, and
configuration. Your data is yours: no lock-in, no fee, no support
ticket needed.

Use it for accountant handoffs, backups, or migrating away (we'd
rather earn the renewal than hold the data hostage).
`,
};

export default article;
